export default {"src":"/_next/static/media/national-id.3c7ac16b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};